// Filter races by ticket condition
const filterRacesByTicket = filter => (races = []) =>
  races
    .filter(r => !!r.tickets)
    .map(r => ({ ...r, tickets: { tickets: r.tickets.tickets.filter(filter) } }))
    .filter(r => !!r.tickets.tickets.length);

// Available id determined by enum-like type
export const filterRacesWithAvailableTickets = filterRacesByTicket(t => t.availability.type === 1);
export const filterRacesWithoutAvailableTickets = filterRacesByTicket(t => t.availability.type !== 1);



// WEBPACK FOOTER //
// ./app/src/components/EventTicketsPage/components/EventTickets/helpers.js